import { createAsyncThunk } from '@reduxjs/toolkit';

import { MyInvestmentsService } from 'api';

import { downloadDocuments } from 'utils';

import { PaginationParams } from 'models';

export const downloadCurrentInvestments = createAsyncThunk(
	'myInvestments/downloadCurrentInvestments',
	(params: PaginationParams) =>
		downloadDocuments(params, `investments.xlsx`, MyInvestmentsService.downloadCurrent),
);
